import { buildOptions, getEndPoints } from "../../../utils/api-call";
import { makeCall } from "../../../utils/request";
import * as storeUtils from "../../../utils/store-handler";
import { EventBus } from "@/event-bus";
import {
  ACTION_FORGOT_PASSWORD,
  ACTION_CONFIRM_FORGOT_PASSWORD,
  ACTION_FETCH_USER_LOGIN,
  COMMIT_SET_USER_LOGIN,
  SET_FROM_LOGIN,
  ACTION_DO_LOGOUT,
  ACTION_UPDATE_USER_INFORMATION,
  ACTION_CHANGE_USER_PASSWORD,
  MUTATION_DO_LOGOUT,
  GETTER_IS_LOGGEDIN,
  GETTER_USER_INFO,
  GETTER_FROM_LOGIN_DETECT,
  GETTERS_CLIENT_SERVICES_CONFIGURATION,
  ACTION_ADD_USER,
  ACTION_GET_USER_LIST,
  MUTATION_SET_USER_LIST,
  GETTER_LIST_USER,
  GETTER_USER_PAGINATION,
  ACTION_GET_USER_DETAIL,
  ACTION_GET_USER_TANGO_BALANCE,
  ACTION_EDIT_USER,
  ACTION_SET_USER_BLOCKING,
  ACTION_SET_REINVITE_USER,
  MUTATION_BLOCK_USER,
  ACTION_GET_USER_LOGIN_INFO,
  ACTION_VERIFY_INVITATION_TOKEN,
  MUTATION_SET_MFA_DATA,
  GETTER_MFA_DATA,
  ACTION_CONFIRM_CHALLENGE,
  ACTION_COGNITO_CONFIRM_PASSWORD,
  ACTION_SET_EMPTY_MFA_DATA,
  ACTION_SET_MFA_METHOD,
  MUTATION_SET_TEMP_USER_INFO,
  GETTER_TEMP_USER_INFO,
  ACTION_SET_TEMP_USER_INFO,
  ACTION_GET_ACTIVITIES_LOG_ENTITIES,
  MUTATION_SET_ACTIVITIES_LOG_ENTITIES,
  GETTER_ACTIVITIES_LOG_ENTITIES,
  ACTION_GET_ACTIVITIES_LOG,
  MUTATION_SET_ACTIVITIES_LOG,
  GETTER_ACTIVITIES_LOG,
  GETTER_ACTIVITIES_LOG_PAGINATION,
  MUTATION_SET_MFA_FE
} from "./constants";
import { EVENT_TOAST_MESSAGE, EVENT_ERROR_TOAST_MESSAGE } from "@/store/events";
import constants from "@/_consts";
import _ from "lodash";
import { options } from "less";

export const state = {
  userInfo: {},
  clientServices: [
    // TODO: call api server to update this, make it empty by default
    constants.clientServicesConfiguration.engagement,
    constants.clientServicesConfiguration.wellmetrics,
    constants.clientServicesConfiguration.coaching
  ],
  users: [],
  pagination: {
    count: 10,
    total: 0
  },
  mfa: {},
  tempUserInfo: {},
  activitiesLogEntities: [],
  activitiesLog: [],
  activitiesLogPagination: {
    count: 10,
    total: 0
  },
  fromLogin: false
};

export const actions = {
  processMFA: (
    { dispatch, commit },
    { options, response, isSetAuthorizationToken }
  ) => {
    if (!response) {
      options.errorHandling("Something went wrong");
      return false;
    }
    if (response.ChallengeName) {
      const mfaData = Object.assign(
        {},
        {
          ...response,
          username: options.data.username
        }
      );
      commit(MUTATION_SET_MFA_DATA, mfaData);
      options.callback({ type: response.ChallengeName, data: response });
    } else if (response.data && response.data.code) {
      if (response.data.code === constants.challengeMFA.PWD_CONFIRMED) {
        options.callback({
          type: constants.challengeMFA.PWD_CONFIRMED,
          data: response.data
        });
      }
    } else if (response.data && response.data.access_token) {
      dispatch("setLoginUserInfo", {
        userData: response.data,
        isSetAuthorizationToken
      });
      options.callback({
        type: constants.challengeMFA.LOGIN,
        data: response.data
      });
    } else if (
      response.AuthenticationResult &&
      response.AuthenticationResult.AccessToken &&
      response.AuthenticationResult.RefreshToken
    ) {
      options.callback({
        type: constants.challengeMFA.PWD_CONFIRMED,
        data: {}
      });
    } else if (options.errorHandling) {
      options.errorHandling(response.message);
    }
  },
  setLoginUserInfo: ({ commit }, { userData, isSetAuthorizationToken }) => {
    if (userData && userData.access_token) {
      const perList = userData.permissions.data.map(p => p.name);
      const userPer = _.chain(perList)
        .groupBy(per => per.split("__")[1])
        .map((p, key) => {
          return {
            actions: p.map(v => v.split("__")[2]),
            subject: [key]
          };
        })
        .value();

      const userInfo = {
        userId: userData.id,
        username: userData.username,
        firstName: userData.first_name,
        lastName: userData.last_name,
        timezone: userData.timezone,
        role: userData.roles.data.map(r => r.name),
        roles: userData.roles,
        permissions: userPer,
        employer_ids: userData.employer_ids,
        is_auto_update_timezone: Boolean(userData.is_auto_update_timezone),
        is_manage_all_client: userData.is_manage_all_client,
        client_admin_employer_id: userData.client_admin_employer_id
      };

      sessionStorage.setItem(constants.LOCAL_STORE.uid, userData.id);
      if (isSetAuthorizationToken) {
        sessionStorage.setItem(
          constants.LOCAL_STORE.accessToken,
          `Bearer ${userData.access_token}`
        );
        sessionStorage.setItem(
          constants.LOCAL_STORE.refreshToken,
          userData.refresh_token
        );
      }
      commit(COMMIT_SET_USER_LOGIN, userInfo);
      commit(MUTATION_SET_MFA_DATA, {});
      commit(MUTATION_SET_TEMP_USER_INFO, {});
    }
  },
  [ACTION_FETCH_USER_LOGIN]: ({ dispatch, commit }, options) => {
    makeCall(
      getEndPoints().users.login,
      buildOptions("POST", options.data),
      commit
    ).then(
      response => {
        if (response.error && options.errorHandling) {
          options.errorHandling(response.error);
        } else if (options.callback) {
          dispatch("processMFA", {
            options,
            response,
            isSetAuthorizationToken: true
          });
        }
      },
      error => {
        if (error.response && error.response.data.error) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          options.errorHandling(storeUtils.handleErrorMessage(error));
        }
      }
    );
  },
  [ACTION_UPDATE_USER_INFORMATION]: ({ commit, getters }, options) => {
    const accessToken = sessionStorage.getItem(
      constants.LOCAL_STORE.accessToken
    );
    options.data = { ...options.data, ...{ token: accessToken } };
    makeCall(
      getEndPoints().users.updateInfo,
      buildOptions("POST", options.data),
      commit
    ).then(
      () => {
        if (options.callback) {
          options.callback();
        }
        // update user info from state
        const currentUserState = getters.GETTER_USER_INFO;
        const userInfo = {
          ...currentUserState,
          ...{
            firstName: options.data.hasOwnProperty("first_name")
              ? options.data.first_name
              : currentUserState.firstName,
            lastName: options.data.hasOwnProperty("last_name")
              ? options.data.last_name
              : currentUserState.lastName,
            timezone: options.data.hasOwnProperty("timezone")
              ? options.data.timezone
              : currentUserState.timezone,
            is_auto_update_timezone: Boolean(
              options.data.hasOwnProperty("is_auto_update_timezone")
                ? options.data.is_auto_update_timezone
                : currentUserState.is_auto_update_timezone
            )
          }
        };

        commit(COMMIT_SET_USER_LOGIN, userInfo);
      },
      error => {
        if (error.response && error.response.data.error) {
          options.errorHandling(storeUtils.handleErrorMessage(error));
        }
      }
    );
  },

  [ACTION_CHANGE_USER_PASSWORD]: ({ commit }, options) => {
    const accessToken = sessionStorage.getItem(
      constants.LOCAL_STORE.accessToken
    );
    options.data = { ...options.data, ...{ token: accessToken } };
    makeCall(
      getEndPoints().users.changePassword,
      buildOptions("POST", options.data),
      commit
    ).then(
      response => {
        if (response && response.error && options.errorHandling) {
          options.errorHandling(response.error);
        } else if (options.callback) {
          options.callback();
        }
      },
      error => {
        options.errorHandling(storeUtils.handleErrorMessage(error));
      }
    );
  },

  [ACTION_DO_LOGOUT]: ({ commit }) => {
    commit("MUTATION_DO_LOGOUT");
  },

  [ACTION_FORGOT_PASSWORD]: ({ commit }, options) => {
    makeCall(
      getEndPoints().users.forgotPassword,
      buildOptions("POST", options.data),
      commit
    ).then(
      () => {
        options.callback();
      },
      error => {
        if (error.response && error.response.data.error) {
          options.errorHandling(storeUtils.handleErrorMessage(error));
        }
      }
    );
  },

  [ACTION_CONFIRM_FORGOT_PASSWORD]: ({ commit }, options) => {
    makeCall(
      getEndPoints().users.confirmForgotPassword,
      buildOptions("POST", options.data),
      commit
    ).then(
      () => {
        options.callback();
      },
      error => {
        if (error.response && error.response.data.error) {
          options.errorHandling(error.response.data.error);
        }
      }
    );
  },

  [ACTION_ADD_USER]: ({ commit }, options) => {
    makeCall(
      getEndPoints().users.add,
      buildOptions("POST", options.data),
      commit
    ).then(
      response => {
        if (typeof response.error === "object") {
          let error = { message: "" };
          let messages = response.error.message;
          for (let key in messages) {
            if (messages.hasOwnProperty(key)) {
              error.message += "<p>" + messages[key] + "</p>";
            }
          }
          options.errorHandling(error);
        } else if (typeof response.error === "string") {
          options.errorHandling(response.error);
        } else if (options.callback) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          options.callback(response);
        }
      },
      error => {
        if (error.response && error.response.data.error) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          options.errorHandling(storeUtils.handleErrorMessage(error));
        }
      }
    );
  },

  [ACTION_GET_USER_LIST]: ({ commit }, options) => {
    makeCall(
      getEndPoints().users.getUsers,
      buildOptions("GET", options),
      commit
    ).then(response => {
      if (response.data) {
        commit(MUTATION_SET_USER_LIST, response);
      }
    });
  },

  [ACTION_GET_USER_DETAIL]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      const detailUrl =
        payload && payload.firstLogin
          ? getEndPoints().users.detail.replace(":id", payload.id) + "?login=1"
          : getEndPoints().users.detail.replace(":id", payload);
      makeCall(detailUrl, buildOptions("GET", {}), commit).then(
        response => {
          if (response.data) {
            resolve(response);
          }
        },
        error => {
          reject(error);
        }
      );
    });
  },

  [ACTION_GET_USER_TANGO_BALANCE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      const url = getEndPoints().users.getUserTangoBalance;
      makeCall(url, buildOptions("PUT", payload), commit).then(
        response => {
          if (response) {
            resolve(response);
          }
        },
        error => {
          reject(error);
        }
      );
    });
  },

  [ACTION_EDIT_USER]: ({ commit }, options) => {
    const detailUrl = getEndPoints().users.edit.replace(":id", options.id);
    makeCall(detailUrl, buildOptions("PUT", options.data), commit).then(
      () => {
        if (options.callback) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          options.callback();
        }
      },
      error => {
        if (error.response && error.response.data.error) {
          options.errorHandling(storeUtils.handleErrorMessage(error));
        }
      }
    );
  },

  [ACTION_SET_USER_BLOCKING]: ({ dispatch, commit }, options) => {
    const blockUserUrl = getEndPoints().users.block.replace(":id", options.id);
    makeCall(blockUserUrl, buildOptions("PUT", options.data), commit)
      .then(() => {
        commit(MUTATION_BLOCK_USER, options);
        const msg = options.data.is_block
          ? "Block user successful"
          : "Unblock user successful";
        EventBus.$emit(EVENT_TOAST_MESSAGE, msg);
      })
      .catch(function(response) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) || "Something went wrong"
        );
      });
  },

  [ACTION_SET_REINVITE_USER]: ({ dispatch, commit }, options) => {
    const reinviteUrl = getEndPoints().users.reinvite.replace(
      ":user_id",
      options.id
    );
    makeCall(reinviteUrl, buildOptions("PUT", options.data), commit)
      .then(() => {
        commit(MUTATION_BLOCK_USER, options);
        EventBus.$emit(EVENT_TOAST_MESSAGE, "Re-invite user successful");
      })
      .catch(function(response) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) || "Something went wrong"
        );
      });
  },

  [ACTION_GET_USER_LOGIN_INFO]: ({ dispatch, commit }, options) => {
    return new Promise((resolve, reject) => {
      const detailUrl = getEndPoints().users.detail.replace(":id", options.id);
      makeCall(detailUrl, buildOptions("GET", {}), commit).then(
        response => {
          if (response.data) {
            dispatch("setLoginUserInfo", {
              userData: response.data,
              isSetAuthorizationToken: false
            });
            resolve(response);
            if (options.callback) {
              options.callback(response.data);
            }
          }
        },
        error => {
          reject(error);
        }
      );
    });
  },

  [ACTION_VERIFY_INVITATION_TOKEN]: ({ dispatch, commit }, invitationToken) => {
    return new Promise((resolve, reject) => {
      const detailUrl = getEndPoints().users.invitation_token.replace(
        ":invitation_token",
        invitationToken
      );
      makeCall(detailUrl, buildOptions("PUT", {}), commit).then(
        response => {
          if (response.data) {
            commit(MUTATION_SET_TEMP_USER_INFO, response.data);
            resolve(response.data);
          }
        },
        error => {
          reject(error);
        }
      );
    });
  },

  [ACTION_CONFIRM_CHALLENGE]: ({ dispatch, commit }, options) => {
    return new Promise((resolve, reject) => {
      const detailUrl = getEndPoints().users.confirmChallenge;
      makeCall(detailUrl, buildOptions("POST", options.data), commit)
        .then(response => {
          if (response.data) {
            dispatch("setLoginUserInfo", {
              userData: response.data,
              isSetAuthorizationToken: true
            });
            resolve(response.data);
          }
        })
        .catch(error => {
          if (error.response && error.response.data.error) {
            reject(error.response.data.error);
          }
        });
    });
  },

  [ACTION_COGNITO_CONFIRM_PASSWORD]: ({ dispatch, commit }, options) => {
    return new Promise((resolve, reject) => {
      const detailUrl = getEndPoints().users.cognitoConfirmPassword.replace(
        ":user_id",
        options.id
      );
      makeCall(detailUrl, buildOptions("POST", options.data), commit)
        .then(response => {
          dispatch("processMFA", {
            options,
            response,
            isSetAuthorizationToken: true
          });
          resolve(response);
        })
        .catch(error => {
          if (error.response && error.response.data.error) {
            reject(error.response.data.error);
          }
        });
    });
  },

  [ACTION_SET_EMPTY_MFA_DATA]: ({ commit }) => {
    commit(MUTATION_SET_MFA_DATA, {});
  },

  [ACTION_SET_TEMP_USER_INFO]: ({ commit }, data) => {
    commit(MUTATION_SET_TEMP_USER_INFO, data);
  },

  [ACTION_SET_MFA_METHOD]: ({ commit }, options) => {
    return new Promise((resolve, reject) => {
      const detailUrl = getEndPoints().users.setupMFAMethod;
      makeCall(detailUrl, buildOptions("POST", options.data), commit)
        .then(response => {
          if (response.data) {
            resolve(response.data);
          }
        })
        .catch(error => {
          if (error.response && error.response.data.error) {
            reject(error.response.data.error);
          }
        });
    });
  },

  [ACTION_GET_ACTIVITIES_LOG_ENTITIES]: ({ commit }, options) => {
    makeCall(
      getEndPoints().users.getActivitiesLogEntities,
      buildOptions("GET", options),
      commit
    ).then(response => {
      if (response) {
        commit(MUTATION_SET_ACTIVITIES_LOG_ENTITIES, response);
      }
    });
  },

  [ACTION_GET_ACTIVITIES_LOG]: ({ commit }, options) => {
    makeCall(
      getEndPoints().users.getActivitiesLogs,
      buildOptions("GET", options),
      commit
    ).then(response => {
      if (response.data) {
        commit(MUTATION_SET_ACTIVITIES_LOG, response);
      }
    });
  }
};

export const getters = {
  [GETTER_IS_LOGGEDIN]: () =>
    sessionStorage.getItem(constants.LOCAL_STORE.accessToken) &&
    sessionStorage.getItem(constants.LOCAL_STORE.accessToken).length > 0,
  [GETTER_USER_INFO]: state => {
    return state.userInfo;
  },
  [GETTER_FROM_LOGIN_DETECT]: state => {
    return state.fromLogin;
  },
  [GETTERS_CLIENT_SERVICES_CONFIGURATION]: state => {
    return _.isEmpty(state.clientServices) ? [] : state.clientServices;
  },
  [GETTER_LIST_USER]: state => {
    return state.users;
  },
  [GETTER_USER_PAGINATION]: state => {
    return state.pagination;
  },
  [GETTER_MFA_DATA]: state => {
    return state.mfa;
  },
  [GETTER_TEMP_USER_INFO]: state => {
    return state.tempUserInfo;
  },
  [GETTER_ACTIVITIES_LOG_ENTITIES]: state => {
    return state.activitiesLogEntities;
  },
  [GETTER_ACTIVITIES_LOG]: state => {
    return state.activitiesLog;
  },
  [GETTER_ACTIVITIES_LOG_PAGINATION]: state => {
    return state.activitiesLogPagination;
  }
};

export const mutations = {
  [SET_FROM_LOGIN](state, data) {
    state.fromLogin = data;
  },

  [COMMIT_SET_USER_LOGIN](currentState, users) {
    currentState.userInfo = users;
  },

  [MUTATION_DO_LOGOUT]: currentState => {
    // remove all local storage & user info
    sessionStorage.removeItem(constants.LOCAL_STORE.accessToken);
    sessionStorage.removeItem(constants.LOCAL_STORE.refreshToken);
    sessionStorage.removeItem(constants.LOCAL_STORE.uid);
    localStorage.removeItem(constants.LOCAL_STORE.client);
    localStorage.removeItem(constants.LOCAL_STORE.transactionOnWait);
    localStorage.removeItem(constants.LOCAL_STORE.transactionIsTested);
    currentState.userInfo = {};
  },

  [MUTATION_SET_USER_LIST]: (state, users) => {
    state.users = users.data;
    state.pagination =
      users.meta && users.meta.pagination
        ? {
            ...{
              count: users.meta.pagination.count,
              total: users.meta.pagination.total,
              itemsPerPage: users.meta.pagination.per_page,
              totalPage: users.meta.pagination.total_pages
            }
          }
        : state.pagination;
  },

  [MUTATION_BLOCK_USER]: (state, options) => {
    const index = state.users.findIndex(u => u.id === options.id);
    state.users[index].is_block = options.data.is_block ? 1 : 0;
  },

  [MUTATION_SET_MFA_DATA]: (state, mfaData) => {
    state.mfa = mfaData;
  },

  [MUTATION_SET_TEMP_USER_INFO]: (state, data) => {
    state.tempUserInfo = data;
  },

  [MUTATION_SET_ACTIVITIES_LOG_ENTITIES]: (state, data) => {
    state.activitiesLogEntities = data;
  },

  [MUTATION_SET_ACTIVITIES_LOG]: (state, data) => {
    state.activitiesLog = data.data;
    state.activitiesLogPagination =
      data.meta && data.meta.pagination
        ? {
            ...{
              count: data.meta.pagination.count,
              total: data.meta.pagination.total,
              itemsPerPage: data.meta.pagination.per_page,
              totalPage: data.meta.pagination.total_pages
            }
          }
        : state.activitiesLogPagination;
  },

  [MUTATION_SET_MFA_FE]: (state, payload) => {
    let mfa = payload.mfa;
    if (mfa.ChallengeName) {
      const mfaData = Object.assign(
        {},
        {
          ...mfa,
          username: payload.username
        }
      );
      state.mfa = mfaData;
    }
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/users/index.js